var map = {
	"../pages/approve/approve.module": [
		289,
		3
	],
	"../pages/landing/landing.module": [
		290,
		2
	],
	"../pages/rectify/rectify.module": [
		291,
		1
	],
	"../pages/reject/reject.module": [
		292,
		0
	],
	"../pages/submitted/submitted.module": [
		293,
		4
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 155;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 155
// module chunks = 5